module.exports = __webpack_public_path__ + "img/insurance-logo-6.8da2ce68.png";